export enum QuoteStatus {
  PendingServiceProvider = 'pending_service_provider',
  PendingCustomer = 'pending_customer',
  Accepted = 'accepted',
  CustomerRejected = 'customer_rejected',
  ServiceProviderRejected = 'service_provider_rejected',
}

export interface QuoteItem {
  id?: string;
  title: string;
  quantity: number;
  unit_price: number;
  total: number;
}

export interface QuoteMessage {
  id: string;
  text: string;
  created_at: string;
  customer?: {
    first_name: string;
    last_name: string;
    email: string;
  };
  service_provider_admin?: {
    id: string;
    name?: string;
    email?: string;
  };
}

export interface Quote {
  id: string;
  quote_number?: number;
  status: QuoteStatus | string;
  created_at: string;
  draft_order?: {
    id?: string;
    display_id?: number;
    currency_code?: string;
    total?: number;
    subtotal?: number;
    tax_total?: number;
    items?: QuoteItem[];
  };
  service_provider?: {
    id: string;
    name: string;
    handle?: string;
    logo?: string;
  };
  messages?: QuoteMessage[];
  geo_location?: {
    id: string;
    name: string;
  };
  customer?: {
    first_name: string;
    last_name: string;
    email: string;
  };
}
